/**
 * Counts of generated visuals present in the final page, set by the backend on the terminal
 * page-create payload only. `0` means the type was eligible but none made it into the page; an
 * absent field means not eligible or unknown (experiment off, legacy payload, older backend).
 */
export type GeneratedVisualBlockCounts = {
	imageBlocks?: number;
	mauiAppBlocks?: number;
};

const isBlockCount = (value: unknown): value is number =>
	typeof value === 'number' && Number.isInteger(value) && value >= 0;

/**
 * Reads the generated visual block counts from page-create action data for analytics attributes.
 * Absent or malformed fields are omitted rather than defaulted, so `0` and unknown stay distinct.
 */
export const getGeneratedVisualBlockCounts = (data: unknown): GeneratedVisualBlockCounts => {
	if (typeof data !== 'object' || data === null) {
		return {};
	}
	const { imageBlocks, mauiAppBlocks } = data as Record<string, unknown>;
	return {
		...(isBlockCount(imageBlocks) && { imageBlocks }),
		...(isBlockCount(mauiAppBlocks) && { mauiAppBlocks }),
	};
};
